import { Box, Typography } from "@mui/material";
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';
import { useContext, useEffect, useState } from "react";
import AuthContext from "../../context/AuthContext";
import Fetch from "../../services/Fetch";
import PageContent from "../../components/PageContent";
import PageHero from "../../components/motion/PageHero";
import ScrollReveal from "../../components/motion/ScrollReveal";
import DashboardPanelCard from "../../components/cards/DashboardPanelCard";
import { useConstants } from "../../hooks/UseConstants";
import { getNotificationText } from "../../helper/notificationText";
import { parseApiList } from "../../helper/parseApiList";

function Notifications() {
    const { host, language } = useConstants();
    const isAr = language === 'ar';
    const { wait } = useContext(AuthContext);
    const [loading, setLoading] = useState(true);
    const [items, setItems] = useState([]);

    useEffect(() => {
        if (wait) return;
        const load = async () => {
            setLoading(true);
            const result = await Fetch(`${host}/notification/history?per_page=50`, 'GET');
            setItems(parseApiList(result));
            setLoading(false);
        };
        load();
    }, [host, wait]);

    return (
        <PageContent wait={wait} loading={loading}>
            <PageHero
                title={isAr ? 'الإشعارات' : 'Notifications'}
                subtitle={isAr ? 'آخر التحديثات والتنبيهات الخاصة بك' : 'Your latest updates and alerts'}
                icon={<NotificationsNoneOutlinedIcon />}
            />
            {items.length === 0 ? (
                <Typography color="text.secondary" className="text-center py-12">
                    {isAr ? 'لا توجد إشعارات' : 'No notifications'}
                </Typography>
            ) : (
                <DashboardPanelCard className="mx-0">
                    {items.map((n, i) => {
                        const { title, body } = getNotificationText(n, isAr);
                        return (
                            <ScrollReveal key={n.id || i} delay={i * 40} direction="up">
                                <Box sx={{ py: 1.5, borderBottom: 1, borderColor: 'divider' }}>
                                    <Typography variant="body2" fontWeight={600}>{title}</Typography>
                                    {body ? (
                                        <Typography variant="caption" color="text.secondary" display="block">
                                            {body}
                                        </Typography>
                                    ) : null}
                                    {n.created_at ? (
                                        <Typography variant="caption" display="block" color="text.disabled" sx={{ mt: 0.5 }}>
                                            {n.created_at}
                                        </Typography>
                                    ) : null}
                                </Box>
                            </ScrollReveal>
                        );
                    })}
                </DashboardPanelCard>
            )}
        </PageContent>
    );
}

export default Notifications;
